import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import { Tag } from '@components/common';
import { ListTable } from '@components/table';
import { AppSelectors } from '@redux/AppRedux';

import { COLORS } from '@theme/styles';

import API from '@utils/api';
import history from '@utils/history';
import { formatDate } from '@utils/date';

const PROPERTY_PAGE_SIZES = [25, 50, 100, 250];

const filterDefinitions = [
  {
    key: 'propertyID',
    component: 'NameSearch',
    fetchAPI: API.fetchProperties,
    dataField: 'properties',
    valueKey: 'propertyID',
    width: 6
  },
  {
    key: 'regionID',
    component: 'RegionSearch',
    width: 4
  },
  {
    key: 'city',
    component: 'CitySearch',
    width: 4
  },
  {
    key: 'state',
    component: 'StateSearch',
    width: 4
  },
  {
    key: 'status',
    component: 'BooleanSelect',
    label: 'Status',
    placeholder: 'Status',
    width: 4
  },
  {
    key: 'bedroomsCounts',
    component: 'SimpleSelect',
    label: 'Bedrooms',
    placeholder: 'Bedrooms',
    options: [1, 2, 3, 4],
    width: 2
  }
];

function PropertiesTable(props) {
  const { offices, regions } = props;

  const dataColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true
    },
    {
      title: 'Office',
      mode: 'single',
      dataIndex: 'regionID',
      render: value => {
        const region = regions.find(item => item.regionID === value);
        if (!region) {
          return null;
        }
        const { officeID } = region;
        const office = offices.find(item => item.officeID === officeID);
        if (!office) {
          return null;
        }

        return office.name;
      }
    },
    {
      title: 'State',
      mode: 'single',
      dataIndex: 'state',
      sorter: true
    },
    {
      title: 'City',
      mode: 'single',
      dataIndex: 'city',
      sorter: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      className: 'capitalise',
      render: value => (
        <>
          {value === 'active' ? (
            <Tag content="Active" color={COLORS.success} />
          ) : (
            <Tag content="InActive" color={COLORS.warning} />
          )}
        </>
      )
    },
    {
      title: 'First Day of Service',
      dataIndex: 'firstDayOfService',
      sorter: true,
      render: value => formatDate(value)
    },
    {
      title: 'Buildings',
      dataIndex: 'buildingsNames',
      render: value => {
        if (!value) {
          return;
        }
        let length = value.length - 1;
        return value.map((building, key) => (
          <span key={key}>
            {building}
            {length !== key && ', '}
          </span>
        ));
      }
    },
    {
      title: 'No. of Bedrooms',
      dataIndex: 'bedroomsCounts',
      render: value => {
        let length = value.length - 1;
        return value.map((room, key) => (
          <span key={key}>
            {room}
            {length !== key && ', '}
          </span>
        ));
      }
    },
    {
      title: 'Total No. of Units',
      dataIndex: 'unitsCount',
      sorter: true
    },
    {
      title: () => (
        <Button type="primary">
          <Link to="/properties/create">Create</Link>
        </Button>
      ),
      key: 'action',
      width: 100,
      render: (text, row) => (
        <Button type="primary">
          <Link to={`/properties/${row.propertyID}`}>Details</Link>
        </Button>
      )
    }
  ];

  return (
    <div className="table-view">
      <ListTable
        columns={dataColumns}
        dataId="propertyID"
        filterDefinitions={filterDefinitions}
        pageSizes={PROPERTY_PAGE_SIZES}
        fetchAPI={API.fetchProperties}
        dataFields="properties"
        defaultFilter={{
          status: 'active'
        }}
        defaultPageSize={100}
        onCreate={() => {
          history.push('properties/create');
        }}
      />
    </div>
  );
}

PropertiesTable.propTypes = {
  offices: PropTypes.array,
  regions: PropTypes.array
};

const mapStateToProps = state => ({
  offices: AppSelectors.selectOffices(state),
  regions: AppSelectors.selectRegions(state)
});

export default connect(
  mapStateToProps,
  {}
)(PropertiesTable);
